document.addEventListener('DOMContentLoaded', function() {
    const offset = 100;
    const scrollUp = document.querySelector(".scroll-up");
    const scrollUpSvgPath = document.querySelector(".scroll-up__svg-path");
    if (scrollUp) {
      const pathLength = scrollUpSvgPath.getTotalLength();
  
      const getTop = () =>
        window.pageYOffset || document.documentElement.scrollTop;
  
      scrollUpSvgPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
      scrollUpSvgPath.style.transition = `stroke-dashoffset 20ms`;
  
      //updateDashoffset
      const updateDashoffset = () => {
        const height = document.documentElement.scrollHeight - window.innerHeight;
        const dashoffset = pathLength - (getTop() * pathLength) / height;
        scrollUpSvgPath.style.strokeDashoffset = dashoffset;
      };
  
      //onScroll
      window.addEventListener(
        "scroll",
        () => {
          updateDashoffset();
          if (getTop() > offset) {
            scrollUp.classList.add("scroll-up_active");
          } else {
            scrollUp.classList.remove("scroll-up_active");
          }
        },
        false
      );
  
      //click
      scrollUp.addEventListener(
        "click",
        () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        },
        false
      );
    }
});